import styled from 'styled-components';

export const Container = styled.p`
  font-size: 0.9rem;
  margin: 0;
`;
export const Label = styled.span`
  font-weight: bold;
`;
export const Text = styled.span``;

